module.exports = __webpack_public_path__ + "img/symbol_8.ffa7ca9c.png";